var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTryImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1953 8.02636L12.1397 9.47266L13.0763 8.03386",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 10.9805L12.1443 9.47027",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98047 8.01953H7.61318",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 8.1184V10.9805",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07422 9.56938L10.3161 10.9805",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 8.02397V10.9805",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3448_6602",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 15,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H17V17H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3448_6602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3162 8.78683C10.3162 9.21119 9.94412 9.5552 9.50438 9.5552C9.28629 9.5552 8.72423 9.55859 8.72423 9.55859C8.72423 9.55859 8.72071 9.00072 8.72071 8.78683C8.72071 8.61116 8.71875 8.01846 8.71875 8.01846H9.50438C9.94412 8.01846 10.3162 8.36249 10.3162 8.78683Z",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2429 2.75882C11.2653 2.35872 10.1821 2.16539 9.04719 2.2345C5.42601 2.45504 2.47877 5.3811 2.23558 9.00082C1.93564 13.465 5.68602 17.1541 10.1691 16.7511C13.5027 16.4514 16.2294 13.8501 16.7049 10.537C16.8679 9.40107 16.7561 8.31234 16.4372 7.31458C16.3971 7.18895 16.2581 7.12356 16.134 7.16818L14.8037 7.64651C14.6842 7.68949 14.6233 7.81872 14.6608 7.94009C14.9144 8.76035 14.9865 9.65838 14.7811 10.6038C14.2667 12.9712 12.2274 14.7582 9.8085 14.8938C8.38593 14.9736 7.07273 14.4994 6.06515 13.6675",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37591 12.9883C4.57883 12.0469 4.09766 10.8299 4.09766 9.50263C4.09766 6.52416 6.5208 4.10113 9.49915 4.10113C10.3168 4.10113 11.0911 4.28617 11.7862 4.61307L11.2635 5.22411L14.8889 5.99005L13.5701 2.5273L13.0413 3.14564",
    stroke: "#0C3450",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryImage);
export default __webpack_public_path__ + "static/media/tryImage.9d971f42a081ab0ec096db9d902e6cee.svg";
export { ForwardRef as ReactComponent };